export default {
  LIPCOLOR: [
    '#E0467C',
    '#A7192F',
    '#FF359A',
    '#FF99A4',
    '#DE0848',
    '#D6938A',
    '#C5145D',
    '#FE6F7B',
    '#DE9C87',
    '#EE6883',
  ],
  FOUNDATION: [
    '#FFF3F6',
    '#FBCFCC',
    '#EBC19E',
    '#DEC4B6',
    '#D0A59B',
    '#E1A771',
    '#EE8981',
    '#DB9C82',
    '#985D33',
    '#643116',
  ],
  BLUSH: [
    '#E27E69',
    '#FE8FB8',
    '#D08D7D',
    '#F5C98F',
    '#B9737E',
    '#F37352',
    '#D3A499',
    '#8E525E',
    '#CD936E',
    '#B17E6B',
  ],
  EYELINER: [
    '#000000',
    '#031D80',
    '#4E62DD',
    '#4B1757',
    '#7B0D17',
    '#F14D4C',
    '#C62A00',
    '#62A72A',
    '#B87138',
    '#C0A86F',
  ],
  MASCARA: [
    '#000000',
    '#031D80',
    '#4E62DD',
    '#4B1757',
    '#7B0D17',
    '#F14D4C',
    '#C62A00',
    '#62A72A',
    '#B87138',
    '#C0A86F',
  ],
  EYESHADOW: [
    '#000000',
    '#031D80',
    '#4E62DD',
    '#4B1757',
    '#7B0D17',
    '#F14D4C',
    '#C62A00',
    '#62A72A',
    '#B87138',
    '#C0A86F',
  ],
};
